import get from 'lodash.get';

import { IConfiguredHttp } from './http';

const API_KEY = process.env.GET_ADDRESS_API_KEY || 'GET_ADDRESS_API_KEY_NOT_SET_ERROR';

export interface IAddressLookupResult {
	latitude?: number;
	longitude?: number;
	addresses?: string[];
	statusCode?: number;
	message?: string;
}

export interface IAddressesApi {
	getAddressesByPostcode: (postcode: string) =>  Promise<IAddressLookupResult>;
}

const addressesApiFactory = (http: IConfiguredHttp): IAddressesApi => ({
	getAddressesByPostcode(postcode) {
		return http.get(`/find/${postcode}?api-key=${API_KEY}`).catch((err) => {
			return {
				message: get(err, 'response.data.Message', 'Unknown address lookup error'),
				statusCode: get(err, 'response.status', -1),
				addresses: []
			};
		});
	}
});

export default addressesApiFactory;
